<template>
	<div v-if="inline" class="codegen-shell codegen-shell--inline">
		<slot></slot>
	</div>
	<b-modal v-else size="xl" :id="modalId" :title="title" hide-footer>
		<slot></slot>
	</b-modal>
</template>

<script>
// Coquille de rendu partagée par CodeGenerator.vue : le contenu (slot par
// défaut) est identique dans les deux cas, seul l'habillage change — une
// vraie modale Bootstrap (comportement historique), ou un simple bloc en
// ligne qui vient occuper la place de l'éditeur Ace (mode "test en place",
// cf TODO_CODEGEN_CHAT.md section 10 : proposition v4 de l'utilisateur).
// Le contenu du slot par défaut reste compilé dans le scope du parent
// (CodeGenerator.vue) : ses data/computed/methods restent donc accessibles
// normalement, ce composant ne fait qu'habiller le rendu, sans dupliquer le
// template.
export default {
	name: "codegen_shell",
	props: {
		inline: {
			type: Boolean,
			default: false
		},
		modalId: {
			type: String,
			required: true
		},
		title: {
			type: String,
			default: ""
		}
	}
};
</script>

<style scoped>
.codegen-shell--inline {
	border: 1px solid #dee2e6;
	border-radius: 6px;
	padding: 12px;
	background: #fff;
}
</style>
